import { Avatar, Box, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {
  formatDate,
  formatTime12Hour,
  hasPermission,
  isAdmin,
} from "../utils/commonutils";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export const columnsUserTable = [
  {
    name: "Avatar",
    options: {
      filter: false,
      download: false,
      customBodyRender: (value) => {
        return <Avatar src={value} alt="Avatar"></Avatar>;
      },
    },
  },
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Email",
    options: {
      filter: false,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Mobile",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "ID",
    options: {
      display: "excluded",
      filter: false,
      download: false,
      viewColumns: false,
    },
  },
  {
    name: "Status",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
];

export const columnsCustomerTable = (thisEvt) => [
  {
    name: "ID",
    options: {
      display: "excluded",
      filter: false,
      download: false,
      viewColumns: false,
    },
  },
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value, tableMeta) => {
        if (value) {
          const recordId = tableMeta?.rowData?.[0];
          return (
            <Link
              to={{
                pathname: `/customers/${recordId}`,
                thisEvt,
              }}
            >
              <p>{value}</p>
            </Link>
          );
        }
      },
    },
  },
  //  {
  //   name: "UserName",
  //   options: {
  //     filter: true,
  //     customBodyRender: (value) => {
  //       if (value) {
  //         return (
  //           <span>
  //             <div>
  //               <p>{value}</p>
  //             </div>
  //           </span>
  //         );
  //       }
  //     },
  //   },
  // },
  {
    name: "Email",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Mobile",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Company Name",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Action",
    options: {
      filter: true,
      download: false,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span >
              <div style={{width:"150px"}}>
                {hasPermission("update_customer") && (
                  <IconButton
                    title="Edit"
                    onClick={() => thisEvt.setEditCustomer(value._id, value)}
                  >
                    <EditIcon />
                  </IconButton>
                )}
                {hasPermission("delete_customer") && (
                  <IconButton
                    title="Delete"
                    onClick={() =>
                      thisEvt.openDeleteModal(value._id, thisEvt.onDelete)
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
                {isAdmin() && (
                  <IconButton
                    title="Reset Password"
                    onClick={() => thisEvt.openResetPasswordModal(value)}
                  >
                    <LockResetIcon />
                  </IconButton>
                )}
              </div>
            </span>
          );
        }
      },
    },
  },
];

export const columnsEmployeeTable = (thisEvt) => [
  {
    name: "ID",
    options: {
      display: "excluded",
      filter: false,
      download: false,
      viewColumns: false,
    },
  },
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value, tableMeta) => {
        if (value) {
          const recordId = tableMeta?.rowData?.[0];
          return (
            <Link
              to={{
                pathname: `/employees/${recordId}`,
                thisEvt,
              }}
            >
              <p>{value}</p>
            </Link>
          );
        }
      },
    },
  },
  {
    name: "Email",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Mobile",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Role",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Action",
    options: {
      filter: true,
      download: false,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                {hasPermission("update_employee") ? (
                  <IconButton
                    title="Edit"
                    onClick={() => thisEvt.setEditEmployee(value._id, value)}
                  >
                    <EditIcon />
                  </IconButton>
                ) : "-"}
                {hasPermission("delete_employee") ? (
                  <IconButton
                    title="Delete"
                    onClick={() => thisEvt.openDeleteModal(value._id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                ): "-"}
                {isAdmin() &&
                  String(value?.userId?.role || value?.role).toLowerCase() !== "admin" && (
                  <IconButton
                    title="Reset Password"
                    onClick={() => thisEvt.openResetPasswordModal(value)}
                  >
                    <LockResetIcon />
                  </IconButton>
                )}
              </div>
            </span>
          );
        }
      },
    },
  },
];

export const columnsRolesTable = (thisEvt) => [
  {
    name: "ID",
    options: {
      display: "excluded",
      filter: false,
      download: false,
      viewColumns: false,
    },
  },
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Action",
    options: {
      filter: true,
      download: false,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              {hasPermission("delete_role") ? (
                <div>
                  {/* // thisEvt?.props?.authData?.role === "Super Admin" ? */}
                  <IconButton
                    title="Delete"
                    onClick={() => thisEvt.openRoleDeleteModal(value)}
                  >
                    <DeleteIcon />
                  </IconButton>
                  {/* // : null */}
                </div>
              ) : (
                "-"
              )}
            </span>
          );
        }
      },
    },
  },
];

export const columnsRolePermissionsTable = (thisEvt) => [
  {
    name: "ID",
    options: {
      display: "excluded",
      filter: false,
      download: false,
      viewColumns: false,
    },
  },
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Role",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Permission",
    options: {
      filter: true,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              <div>
                <p>{value}</p>
              </div>
            </span>
          );
        }
      },
    },
  },
  {
    name: "Action",
    options: {
      filter: true,
      download: false,
      customBodyRender: (value) => {
        if (value) {
          return (
            <span>
              {hasPermission("delete_role") ? (
                <div>
                  {/* // thisEvt?.props?.authData?.role === "Super Admin" ? */}
                  <IconButton
                    title="Delete"
                    onClick={() => thisEvt.openDeleteModal(value)}
                  >
                    <DeleteIcon />
                  </IconButton>
                  {/* // : null */}
                </div>
              ) : (
                "-"
              )}
            </span>
          );
        }
      },
    },
  },
];

export const columnsFollowupTable = (thisEvt) => [
  {
    name: "Title",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Date",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{formatDate(value)}</p> : null),
    },
  },
  {
    name: "Time",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  // {
  //   name: "Customer",
  //   options: {
  //     filter: true,
  //     customBodyRender: (value) =>
  //       value ? <p>{value}</p> : null,
  //   },
  // },
  // {
  //   name: "Employee",
  //   options: {
  //     filter: true,
  //     customBodyRender: (value) =>
  //       value ? <p>{value}</p> : null,
  //   },
  // },
  {
    name: "Note",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Priority",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Status",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className="table-tag">
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Action",
    options: {
      filter: false,
      download: false,
      customBodyRender: (value) => {
        return (
          <span>
            {hasPermission("update_followup") && (
              <IconButton title="Edit" onClick={() => thisEvt.onEdit(value)}>
                <EditIcon />
              </IconButton>
            )}
            {hasPermission("delete_followup") && (
              <IconButton
                title="Delete"
                onClick={() => thisEvt.onDelete(value._id)}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </span>
        );
      },
    },
  },
];

export const columnsDocumentTable = (thisEvt) => [
  {
    name: "Document Name",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p onClick={()=>thisEvt.handleonRowClick(value)} style={{cursor:"pointer"}}>{value.fileName}</p> : null),
    },
  },
  {
    name: "Uploaded By",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Type",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? <p>{value.toUpperCase()}</p> : null,
    },
  },
  {
    name: "File Type",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
   {
    name: "Category",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Uploaded at",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{formatDate(value)}</p> : null),
    },
  },
    {
    name: "Action",
    options: {
      filter: false,
      download: false,
      customBodyRender: (value) => {
        return (
          <span>
              <IconButton
                title="Preview"
                onClick={() => thisEvt.handleonRowClick(value)}
              >
                <VisibilityIcon />
              </IconButton>
              <IconButton
                title="Download"
                onClick={() => thisEvt.handleDownload?.(value)}
              >
                <CloudDownloadIcon />
              </IconButton>
              {hasPermission("delete_document") && (
              <IconButton
                title="Delete"
                onClick={() => thisEvt.openDeleteModal(value._id)}
              >
                <DeleteIcon />
              </IconButton>
              )}
            
          </span>
        );
      },
    },
  },
];

export const columnsGSTCaseTable = (thisEvt) => [
  {
    name: "Case No.",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Taxpayer Name",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "GSTIN",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Subject",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Disputed Amount",
    options: {
      filter: false,
      customBodyRender: (value) =>
        value ? <p>₹{Number(value).toLocaleString()}</p> : null,
    },
  },
  {
    name: "Stage",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Status",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className="table-tag">
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Action",
    options: {
      filter: false,
      download: false,
      customBodyRender: (value) => {
        return (
          <span>
            <IconButton size="small" title="View" onClick={() => thisEvt.onView(value)}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
            {hasPermission("update_casemanagement") && (
              <IconButton title="Edit" onClick={() => thisEvt.onEdit(value)}>
                <EditIcon />
              </IconButton>
            )}
            {hasPermission("delete_casemanagement") && (
              <IconButton
                title="Delete"
                onClick={() => thisEvt.onDelete(value._id)}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </span>
        );
      },
    },
  },
];

export const columnsCommunicationTable = (thisEvt) => [
  {
    name: "Date",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{formatDate(value)}</p> : null),
    },
  },
  {
    name: "Time",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Type",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Channel",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Related To",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className="table-tag">
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Subject",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Action",
    options: {
      filter: false,
      download: false,
      customBodyRender: (value) => (
        <span>
          {hasPermission("update_communication") && (
            <IconButton title="Edit" onClick={() => thisEvt.onEdit(value)}>
              <EditIcon />
            </IconButton>
          )}
          {hasPermission("delete_communication") && (
            <IconButton
              title="Delete"
              onClick={() => thisEvt.onDelete(value._id)}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </span>
      ),
    },
  },
];

export const columnsAuditReportTable = (thisEvt) => [
  {
    name: "Date",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Time",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "User",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Role",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className="table-tag">
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Activity",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <strong>{value}</strong> : null),
    },
  },
  {
    name: "Details",
    options: {
      filter: false,
      customBodyRender: (value) =>
        value ? <p style={{ whiteSpace: "pre-wrap" }}>{value}</p> : null,
    },
  },
];
export const columnsInquiryTable = (thisEvt) => [
  {
    name: "Name",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <strong>{value}</strong> : null),
    },
  },
  {
    name: "Service",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Priority",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className={`table-tag priority-badge priority-${value?.toLowerCase()}`}>
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Status",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className={`table-tag status-badge status-${String(value).toLowerCase().replace(/\s+/g, "-")}`}>
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Assigned to",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Next follow-up",
    options: {
      filter: false,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  // NEW FIELDS END

  {
    name: "Type",
    options: {
      filter: true,
      customBodyRender: (value) =>
        value ? (
          <span className="table-tag table-tag--soft">
            {value}
          </span>
        ) : null,
    },
  },
  {
    name: "Channel",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Related To",
    options: {
      filter: true,
      customBodyRender: (value) => (value ? <p>{value}</p> : null),
    },
  },
  {
    name: "Subject",
    options: {
      filter: false,
      customBodyRender: (value) =>
        value ? <p style={{ whiteSpace: "pre-wrap" }}>{value}</p> : null,
    },
  },

  // Followup button
  {
    name: "",
    options: {
      filter: false,
      customBodyRender: () => {
        return (
          <span>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => console.log("Add Follow-up clicked")}
            >
              Follow-up
            </Button>
          </span>
        );
      },
    },
  },

  // Action column (unchanged)
  {
    name: "Action",
    options: {
      filter: false,
      customBodyRender: (value) => {
        return (
          <span>
            {hasPermission("update_paymentrecovery") && (
              <IconButton title="Edit" onClick={() => thisEvt.onEdit(value)}>
                <EditIcon />
              </IconButton>
            )}
            {hasPermission("delete_paymentrecovery") && (
              <IconButton
                title="Delete"
                onClick={() => thisEvt.onDelete(value._id)}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </span>
        );
      },
    },
  },
];
export const columnsPaymentRecoveryTable = (thisEvt) => [
  {
    name: "Diary No.",
    options: {
      filter: true,
      customBodyRender: (value) => <p>{value}</p>,
    },
  },
  {
    name: "Applicant",
    options: {
      filter: true,
      customBodyRender: (value) => <p>{value}</p>,
    },
  },
  {
    name: "Buyer",
    options: {
      filter: true,
      customBodyRender: (value) => <p>{value}</p>,
    },
  },
  {
    name: "Amount",
    options: {
      filter: false,
      customBodyRender: (value) => <p>{value ? `₹${value}` : "-"}</p>,
    },
  },
  {
    name: "Case No.",
    options: {
      filter: true,
      customBodyRender: (value) => <p>{value || "-"}</p>,
    },
  },
  {
    name: "Status",
    options: {
      filter: true,
      customBodyRender: (value) => <p>{value || "-"}</p>,
    },
  },
  {
    name: "Stage",
    options: {
      filter: true,
      customBodyRender: (value) => <p>{value || "-"}</p>,
    },
  },
  {
    name: "Legal notice",
    options: {
      filter: false,
      customBodyRender: (value) => <p>{formatDate(value) || "-"}</p>,
    },
  },
  {
    name: "Action",
    options: {
      filter: false,
      download: false,
      customBodyRender: (value) => (
        <span>
          <IconButton size="small" title="View" onClick={() => thisEvt.onView(value)}>
            <VisibilityIcon fontSize="small" />
          </IconButton>
          {hasPermission("update_paymentrecovery") && (
            <IconButton size="small" title="Edit" onClick={() => thisEvt.onEdit(value)}>
              <EditIcon fontSize="small" />
            </IconButton>
          )}
          {hasPermission("delete_paymentrecovery") && (
            <IconButton
              size="small"
              title="Delete"
              onClick={() => thisEvt.onDelete(value._id)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </span>
      ),
    },
  },
];
